export const content = {
  mehrerePendants: 'Mehr als ein Pendant-Thema gefunden',
} as const;
